module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "main-fade",
      "mode": "out-in"
    }
  }, [_c('header', [_c('div', {
    key: "show",
    staticClass: "header-show"
  }, [_c('repeat-img', {
    attrs: {
      "isLink": _vm.isLink,
      "size": _vm.size,
      "images": _vm.images_arr
    }
  })], 1), _vm._v(" "), (_vm.headerinfo.showtime) ? _c('header-title', {
    attrs: {
      "headerinfo": _vm.headerinfo
    }
  }) : _vm._e(), _vm._v(" "), _c('meeting-info', {
    attrs: {
      "headerinfo": _vm.headerinfo
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13c9079e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Headershow.vue
// module id = 162
// module chunks = 1